export enum OrderformParticipantsAmounttype {
  Single = 'single',
  Multiple = 'multiple'
}

export enum OrderformParticipantsFormmode {
  Select = 'select',
  Form = 'form'
}

export const OrderformParticipantsConfig = {
  moderator: {
    amount: OrderformParticipantsAmounttype.Single,
    mode: OrderformParticipantsFormmode.Select,
    silentobserver: false
  },
  observer: {
    amount: OrderformParticipantsAmounttype.Multiple,
    mode: OrderformParticipantsFormmode.Select,
    silentobserver: true
  },
  observer_gem: {
    amount: OrderformParticipantsAmounttype.Multiple,
    mode: OrderformParticipantsFormmode.Select,
    silentobserver: true
  },
  orderer: {
    amount: OrderformParticipantsAmounttype.Single,
    mode: OrderformParticipantsFormmode.Form,
    silentobserver: true
  },
  hiringmanager: {
    amount: OrderformParticipantsAmounttype.Single,
    mode: OrderformParticipantsFormmode.Form,
    silentobserver: true
  },
  workers_council: {
    amount: OrderformParticipantsAmounttype.Single, // Multiple?
    mode: OrderformParticipantsFormmode.Form,
    silentobserver: true
  },
  disabled_persons_representative: {
    amount: OrderformParticipantsAmounttype.Single, // Multiple?
    mode: OrderformParticipantsFormmode.Form,
    silentobserver: true
  },
  hr_businesspartner: {
    amount: OrderformParticipantsAmounttype.Single, // Multiple?
    mode: OrderformParticipantsFormmode.Form,
    silentobserver: true
  },
  executive_contact: {
    amount: OrderformParticipantsAmounttype.Single, // Multiple?
    mode: OrderformParticipantsFormmode.Form,
    silentobserver: true
  },
  other: {
    amount: OrderformParticipantsAmounttype.Multiple,
    mode: OrderformParticipantsFormmode.Form,
    silentobserver: true
  },
}
